import { removeClass } from '@opten/dom/remove-class';
import { addClass } from '@opten/dom/add-class';
import { Component } from '@opten/compiler/metadata/component';

import { FilterHelper } from '../shared/filter-helper';

@Component({ className: 'js-book' })
export class BookComponent {
	constructor(private element: HTMLElement) {
		const forms = Array.from(
			this.element.querySelectorAll('.js-book-form')
		) as HTMLFormElement[];
		forms.forEach((form) => {
			new FilterHelper(form, {
				filterControlSelector: '.js-book-control',
				filterFormSelector: '.js-book-form',
				onReset: () => {},
				onSubmit: () => {
					const submitBtn = form.querySelector(
						'[type="submit"]'
					) as HTMLButtonElement;
					const btnIcon = submitBtn.querySelector('.icon');
					submitBtn.disabled = true;
					if (btnIcon) {
						addClass(btnIcon, 'c-spinner');
					}

					const formData = Array.from(new FormData(form)).filter(
						(o) => !!o[1]
					);
					const formDataGrouped: any = formData.reduce(
						(arr: any[], ob) => {
							const x = arr.find((o) => o[0] === ob[0]);
							x ? x[1].push(ob[1]) : arr.push([ob[0], [ob[1]]]);
							return arr;
						},
						[]
					);
					let filename;
					let contentType;
					fetch(
						`${form.action}?${formDataGrouped
							.map((o) => `${o[0]}=${o[1].join(',')}`)
							.join('&')}`,
						{
							method: 'get',
							cache: 'default',
							credentials: 'same-origin',
							headers: {
								'Content-Type':
									'application/x-www-form-urlencoded',
								'accept-language':
									document.documentElement.lang,
								'X-Requested-With': 'XMLHttpRequest',
							},
						}
					)
						.then((response) => {
							if (response.ok === false) {
								throw Error;
							}
							filename = this.getFileName(
								response.headers.get('content-disposition')
							);
							contentType = response.headers.get('content-type');
							return response.blob();
						})
						.then((blob) => {
							const newBlob = new Blob([blob], {
								type: contentType,
							});

							// MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
							if (
								window.navigator &&
								window.navigator.msSaveOrOpenBlob
							) {
								window.navigator.msSaveOrOpenBlob(
									newBlob,
									filename
								);
							} else {
								// For other browsers: create a link pointing to the ObjectURL containing the blob.
								const objUrl = URL.createObjectURL(newBlob);

								let link = document.createElement('a');
								link.href = objUrl;
								link.download = filename;
								link.click();

								// For Firefox it is necessary to delay revoking the ObjectURL.
								setTimeout(() => {
									URL.revokeObjectURL(objUrl);
								}, 250);
							}
						})
						.catch((error) => {
							const errorSpan = document.createElement('span');
							errorSpan.classList.add('mx-4');
							errorSpan.style.color = 'red';
							errorSpan.innerText = 'An error has occurred';
							submitBtn.parentNode.insertBefore(
								errorSpan,
								submitBtn
							);
							setTimeout(() => {
								errorSpan.remove();
							}, 5000);
						})
						.finally(() => {
							submitBtn.disabled = false;
							if (btnIcon) {
								removeClass(btnIcon, 'c-spinner');
							}
						});
				},
				onRemoveFilter: (value, name) => {},
			});
		});
	}

	private getFileName(disposition: string): string {
		const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
		const asciiFilenameRegex = /^filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

		let fileName: string = null;
		if (utf8FilenameRegex.test(disposition)) {
			fileName = decodeURIComponent(
				utf8FilenameRegex.exec(disposition)[1]
			);
		} else {
			// prevent ReDos attacks by anchoring the ascii regex to string start and
			//  slicing off everything before 'filename='
			const filenameStart = disposition
				.toLowerCase()
				.indexOf('filename=');
			if (filenameStart >= 0) {
				const partialDisposition = disposition.slice(filenameStart);
				const matches = asciiFilenameRegex.exec(partialDisposition);
				if (matches != null && matches[2]) {
					fileName = matches[2];
				}
			}
		}
		return fileName;
	}
}
